var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalAcessoSistema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86361 16.8C2.64725 16.8 2.46576 16.7272 2.31914 16.5816C2.17252 16.436 2.09947 16.256 2.09998 16.0417C2.09998 15.8268 2.17329 15.6466 2.31991 15.501C2.46652 15.3554 2.64776 15.2828 2.86361 15.2834H18.1363C18.3527 15.2834 18.5342 15.3562 18.6808 15.5018C18.8274 15.6474 18.9005 15.8273 18.9 16.0417C18.9 16.2565 18.8267 16.4368 18.68 16.5824C18.5334 16.728 18.3522 16.8005 18.1363 16.8H2.86361ZM4.39089 14.525C3.97089 14.525 3.61121 14.3764 3.31187 14.0791C3.01252 13.7819 2.86311 13.4249 2.86361 13.0084V4.66669C2.86361 4.24961 3.01329 3.89243 3.31263 3.59517C3.61198 3.2979 3.9714 3.14952 4.39089 3.15003H16.6091C17.0291 3.15003 17.3887 3.29866 17.6881 3.59593C17.9874 3.89319 18.1368 4.25011 18.1363 4.66669V13.0084C18.1363 13.4254 17.9867 13.7826 17.6873 14.0799C17.388 14.3771 17.0286 14.5255 16.6091 14.525H4.39089Z",
    fill: "#34639C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalAcessoSistema);
export default __webpack_public_path__ + "static/media/IconModalAcessoSistema.44501be2e9a11a345cee314a2739f581.svg";
export { ForwardRef as ReactComponent };